import { useHMSRoom } from "../hms";
import { useLivekitRoom } from "../livekit";
import type { ProviderRoomOptions } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderRoom = (params: ProviderRoomOptions) =>
  useProviderHook({
    hms: useHMSRoom,
    livekit: useLivekitRoom,
  })(params);
